import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

import {
  useCheckpoint,
  useGoToLevel,
  useIntlMessages,
  usePagination,
} from 'src/hooks';

import {
  MenuFrame,
  PageLoader,
  ContentContainer,
  Navbar,
  Image,
} from 'src/components/common';

import './index.scss';
import { checkpoints, video } from 'src/constants';

const Container = ({
  currency,
  getCollectionsByGroupId,
  groupData,
  hasLoaded,
  items,
  levelsPath,
}) => {
  const goToLevel = useGoToLevel(levelsPath);
  const { groupId } = useParams();

  const messages = useIntlMessages();

  const {
    currentPage,
    pageCount,
    handlePreviousPage,
    handleNextPage,
    pageItems,
  } = usePagination(items);

  useEffect(() => {
    getCollectionsByGroupId(groupId);
  }, [getCollectionsByGroupId, groupId]);

  useCheckpoint(checkpoints.FIRST_TIME_ON_TREASURE_HUNT, hasLoaded);

  if (!hasLoaded) {
    return <PageLoader />;
  }

  return (
    <PageLoader isFadingOut>
      <Navbar.GameNavbar
        currency={currency}
        title={groupData.label}
        videoLabel={messages.subactivity.treasureHunt}
        videoName={video.NAME.TREASURE_HUNT}
      />
      <div
        className={`treasure-hunt-collections-container treasure-hunt-collections-container--background-${groupData.orderNumber}`}
      >
        <MenuFrame
          title={groupData.label}
          currencyImageUrl={currency.imageUrl}
          currentPageNumber={currentPage}
          pagesCount={pageCount}
          onBack={handlePreviousPage}
          onForward={handleNextPage}
        >
          <div className="treasure-hunt-collections-container__collections">
            {pageItems?.map((collection) => (
              <ContentContainer
                key={collection.id}
                isLocked={collection.isLocked}
                onClick={() => goToLevel(collection.id)}
                showFeedback={collection.showFeedback}
                isFeedbackPositive={collection.isFeedbackPositive}
                variant="small"
              >
                <Image alt="thumbnail" src={collection.imageUrl} />
              </ContentContainer>
            ))}
          </div>
        </MenuFrame>
      </div>
    </PageLoader>
  );
};

Container.propTypes = {
  currency: PropTypes.shape({
    imageUrl: PropTypes.string,
  }).isRequired,
  getCollectionsByGroupId: PropTypes.func.isRequired,
  groupData: PropTypes.shape({
    label: PropTypes.string,
    orderNumber: PropTypes.number,
  }).isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  levelsPath: PropTypes.string.isRequired,
};

export default memo(Container);
